import { useRef, useState } from 'react';
import style from '../styles/VenueCard.module.css';
import { trpc } from '../utils/trpc';
import ReactDOM from 'react-dom';
import VenueProfile from '../page-components/VenueProfile';

interface VenueCardProps {
  id: string;
}

/**
 * A template component to render individual venue overviews
 * Accepts a venue id as a prop to determine subject
 * @returns Individual venue overview card
 */
export function VenueCard({ id }: VenueCardProps) {
  // Setup use references
  const cardRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const { data: venueQuery, isLoading } = trpc.venue.getById.useQuery({ venue_id: id });

  // Initialize banner image reference
  const bannerUrl = venueQuery?.banner_url;

  // Dynamic styles for the background banner
  const dynamicBackgroundStyle = bannerUrl
    ? {
        backgroundImage: `linear-gradient(to right, #2D4F2B 20%, transparent 100%), url(${bannerUrl})`,
        backgroundSize: '100%, cover',
        backgroundPosition: '0 0, center',
      }
    : {};

  // Standard display
  return isLoading ? (
    // Loading placeholder
    <div className={style.skeletonCard}>
      <div className={style.skeletonTitle}></div>
      <div className={style.skeletonText}></div>
    </div>
  ) : (
    // Successful retrieval
    <div
      ref={cardRef}
      className={style.venueCardContainer}
      onClick={() => setOpen(true)}
      style={dynamicBackgroundStyle}
    >
      {/* Venue name display */}
      <h2>{venueQuery.venue_name}</h2>

      {/* Venue address display */}
      <h3>{venueQuery.address}</h3>

      {/* Expanded information modal */}
      {open &&
        ReactDOM.createPortal(
          <VenueProfile venueId={venueQuery?.venue_id} onClose={() => setOpen(false)} />,
          document.body,
        )}
    </div>
  );
}
